import { createAction } from '@ngrx/store';

const openHowToPlayDialog = createAction('[HowToPlay] Open How To Play Dialog');

export const howToPlayActions = {
  openHowToPlayDialog,
};
